const custom_profile_fields = {
    /** UNTRANSLATED */
    entity_not_exists_with_names: 'Cannot find entities with the given names: {{names}}',
    invalid_min_max_input: 'Nieprawidłowe wartości minimalne lub maksymalne.',
    invalid_options: 'Nieprawidłowe opcje pól.',
    invalid_regex_format: 'Nieprawidłowy format wyrażenia regularnego.',
    invalid_address_parts: 'Nieprawidłowe części adresu.',
    invalid_fullname_parts: 'Nieprawidłowe części pełnego imienia i nazwiska.',
    name_exists: 'Pole o podanej nazwie już istnieje.',
    conflicted_sie_order: 'Konfliktowa wartość kolejności pola dla Sign-in Experience.',
    /** UNTRANSLATED */
    invalid_name: 'Invalid field name, only letters or numbers are allowed, case sensitive.',
};
export default Object.freeze(custom_profile_fields);
